import { Room, Participant } from 'livekit-client';

/**
 * Находит участника по SID в комнате
 * @param room - LiveKit room
 * @param sid - Participant SID
 * @returns Participant или null если не найден
 */
export const findParticipantBySid = (room: Room, sid: string): Participant | null => {
    if (!sid) return null;

    // проверяем локального участника
    if (room.localParticipant.sid === sid) {
        return room.localParticipant;
    }

    // remoteParticipants использует identity как ключ, а не SID, поэтому нужно итерироваться
    for (const remoteParticipant of room.remoteParticipants.values()) {
        if (remoteParticipant.sid === sid) {
            return remoteParticipant;
        }
    }

    return null;
};
